/**
 * Permissões que vêm JUNTO com outras — espelho de `PERMISSOES_INCLUIDAS` em
 * `src/common/dominio/permissoes.ts` do backend.
 *
 * Quem aplica a regra é o SERVIDOR: o `/me` já devolve as chaves incluídas, e é
 * por elas que o `pode()` decide. Esta cópia existe só para a tela de cargos
 * mostrar "Tutores → Criar" marcado quando "Pacientes → Criar" está — sem ela,
 * o checkbox desmarcado diria que o cargo não pode o que na prática pode.
 *
 * ⚠️ Alterar lá exige alterar aqui.
 */
export const PERMISSOES_INCLUIDAS: Readonly<Record<string, readonly string[]>> = {
  'pacientes.visualizar': ['tutores.visualizar'],
  'pacientes.criar': ['tutores.visualizar', 'tutores.criar'],
  'pacientes.editar': ['tutores.visualizar', 'tutores.criar', 'tutores.editar'],
};

/** A chave marcada que inclui `chave`, ou `null` se nenhuma das marcadas a inclui. */
export function incluidaPor(chave: string, marcadas: ReadonlySet<string>): string | null {
  for (const origem of marcadas) {
    if (PERMISSOES_INCLUIDAS[origem]?.includes(chave)) return origem;
  }
  return null;
}
